import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../httpClient/serverApi/requests/Request';

export interface IDisableIdentityMigrationInfoToastParams {
}

export class DisableIdentityMigrationInfoToastRequest extends Request<IDisableIdentityMigrationInfoToastParams, IResult> {
  constructor(params: IDisableIdentityMigrationInfoToastParams = {}) {
    super('disableIdentityMigrationInfoToast', params);
  }
}
